import { getMerchantListGIGR, merchantRegistrationDetail, postActivationBulkGIGR, putUpdateStatusMerchantGIGR, updateGrMerchant } from '../../utils/api';
import { FAILED, FILTER, LOADING, SUCCESS } from './constants';


export const fetchMerchantList = (params) => {
  return async (dispatch) => {
    const key = 'MerchantList';
    dispatch(loadingAction(true, key));
    try {
      const data = await getMerchantListGIGR(params);
      dispatch(successAction(data, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const fetchUpdateMerchantStatus = (id, payload, action) => {
  return async (dispatch) => {
    const key = 'UpdateMerchantStatus';
    dispatch(loadingAction(true, key));
    try {
      const data = await putUpdateStatusMerchantGIGR(id, payload);
      data['action'] = action || 'nonactivate';
      dispatch(successAction(data, key));
    } catch (error) {
      let message = error?.message || 'Terjadi kesalahan saat memperbarui status pangkalan';
      if(error.status === 'CONFLICT'){
        message = 'Status pangkalan tidak dapat diubah, periksa kembali status pangkalan';
      }
      const data = {
        ...error,
        ...payload
      };
      dispatch(failedAction(message, key, data));
    }
  };
};

export const fetchMerchantById = (id) => {
  return async (dispatch) => {
    const key = 'MerchantById';
    dispatch(loadingAction(true, key));
    try {
      const data = await merchantRegistrationDetail(id);
      dispatch(successAction(data, key));
    } catch (error) {
      let message = error?.message || 'Terjadi kesalahan saat mengambil data pangkalan';
      if(error.status === 'NOT_FOUND'){
        message = 'Data pangkalan tidak ditemukan, periksa kembali ID pangkalan';
      }
      dispatch(failedAction(message, key));
    }
  };
};

export const submitActivationBulkGIGR = (file, callback = () => {}) => {
  return async (dispatch) => {
    const key = 'ActivationBulkGIGR';
    dispatch(loadingAction(true, key));
    callback();
    try{
      const data = await postActivationBulkGIGR(file);
      dispatch(successAction(data, key, 'Aktivasi pangkalan berhasil'));
    }catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const fetchUpdateGrMerchant = () => {
  return async (dispatch) => {
    const key = 'UpdateGRMerchant';
    dispatch(loadingAction(true, key));
    try {
      const data = await updateGrMerchant();
      dispatch(successAction(data, key));
    } catch (error) {
      let message = error?.message || 'Terjadi kesalahan saat mengambil data pangkalan';
      dispatch(failedAction(message, key, error));
    }
  };
};

export function setGRGRFilter(filter) {
  return async (dispatch) => {
    dispatch(
      setFilterAction({
        key: 'table',
        filter,
      })
    );
  };
}

export const clearRedux = (key) => {
  return (dispatch) => {
    dispatch(failedAction('', key, {}));
    dispatch(loadingAction(false, key));
    dispatch(successAction({}, key, ''));
  };
};

export function failedAction(message, key, data = null) {
  return { type: FAILED, message, key, data };
}

export function loadingAction(isLoading, key) {
  return { type: LOADING, isLoading, key };
}

export function successAction(data, key, message = '') {
  return { type: SUCCESS, data, message, key };
}

export function setFilterAction({ key, filter = {} }) {
  return { type: FILTER, key, filter };
}
